import React, { useState } from 'react';
import classnames from 'classnames';
import { ToggleMenu } from '@nutastic/nutastic-react-app';

const Sidebar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const componentClass = 'sidebarMenu';
    const classes = classnames(componentClass, 'animated', 'fadeInRight');

    return <div className={classes}>
        <div className={`${componentClass}__menu-btn`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <i className={ isMenuOpen ? 'ion-ios-close' : 'ion-ios-menu' } />
        </div>

        <ToggleMenu isOpen={isMenuOpen} animation="slideFromRight" onOuterClick={() => setIsMenuOpen(false)}>
            <a href="/home">Home</a>
            <a href="/about">Details</a>
            <a href="/gallery">Gallery</a>
            <a href="/reserve">RSVP</a>
        </ToggleMenu>
    </div>;
};

export default Sidebar;
